<div class="wrapper py-2">
  <div class="row px-3">
    <div class="col-6 h5 font-weight-bold text-left">Inventory Management</div>
  </div>
  <div class="col-12">
    <div class="row row-cols-1 row-cols-md-2 row-cols-xl-5 g-2 mb-2">
      <div class="col mt-2">
        <inventory-management-card id="not-on-site" [title]="'Not On Site'" [count]="inventoryManagementDetails?.notOnSite" (clicked)="quickFilterAction($event)"></inventory-management-card>
      </div>
      <div class="col mt-2">
        <inventory-management-card id="condition-pending" [title]="'Condition Pending'" [count]="inventoryManagementDetails?.conditionPending" (clicked)="quickFilterAction($event)"></inventory-management-card>
      </div>
      <div class="col mt-2">
        <inventory-management-card id="awaiting-title" [title]="'Awaiting Title'" [count]="inventoryManagementDetails?.awaitingTitle" (clicked)="quickFilterAction($event)"></inventory-management-card>
      </div>
      <div class="col mt-2">
        <inventory-management-card id="needs-decommissioning" [title]="'Needs Decommissioning'" [count]="inventoryManagementDetails?.needsDecommissioning" (clicked)="quickFilterAction($event)"></inventory-management-card>
      </div>
      <div class="col mt-2">
        <inventory-management-card id="auction-ready" [title]="'Auction Ready'" [count]="inventoryManagementDetails?.auctionReady" (clicked)="quickFilterAction($event)"></inventory-management-card>
      </div>
    </div>
  </div>
</div>
